import { apiClient } from './client';

/**
 * `POST /v1/prototype-access/refresh` (spec R7.6).
 *
 * Sets a 30-minute `HttpOnly` cookie scoped to the file origin's parent domain,
 * which the file server checks on every asset request. It is invisible to the
 * user: the viewer calls it when it opens, again on a 25-minute timer while it
 * is open, and once more whenever the agent reports a `401` on an asset.
 */
export const refreshPrototypeAccess = async (): Promise<void> => {
  await apiClient.post('/prototype-access/refresh');
};
